<template>
  <div>
    <h3>Commandes passées</h3>

    <table class="table">
      <thead>
      <tr>
        <th scope="col"># de facture</th>
        <!-- <th scope="col">Date de paiement</th> -->
        <th scope="col">Statut</th>
        <th scope="col">Total</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(order, index) in invoices" :key="index">
        <td>{{ order.number }}</td>
        <!-- <td>{{ order.at | formatDateAndTime }}</td> -->
        <td>
          <div class="payment">
            Payée
          </div>
        </td>
        <td>{{ order.amount | formatMoney }}</td>
        <td>
          <b-button  @click="openDetailsModal(order)">Détails</b-button>
        </td>
      </tr>
      <tr v-if="invoices.length === 0">
        <td colspan="5">
          Vous n'avez aucune commande pour le moment.
        </td>
      </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'member-orders-list',
    data() {
      return {
        invoices: []
      };
    },
    methods: {
      ...mapActions('orders', {
        getInvoices: 'getOrders'
      }),
      openDetailsModal(order) {
        window.open(order.url, '_blank');
      },
      async loadInvoices() {
        this.invoices = await this.getInvoices();
      }
    },
    async mounted() {
      await this.loadInvoices();
    }
  };
</script>

<style scoped></style>
